import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getSocialLinks, createSocialLink, updateSocialLink, deleteSocialLink, type SocialLink } from '../../services/api/social';

const PLATFORMS = ['Instagram', 'YouTube', 'TikTok', 'Facebook', 'Spotify', 'X', 'Bandcamp', 'SoundCloud'];

export default function SocialLinksManagerPage() {
  const { t } = useTranslation();
  const [links, setLinks] = useState<SocialLink[]>([]);
  const [loading, setLoading] = useState(true);
  const [newPlatform, setNewPlatform] = useState('');
  const [newUrl, setNewUrl] = useState('');

  useEffect(() => {
    getSocialLinks()
      .then(setLinks)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  async function handleAdd(e: React.FormEvent) {
    e.preventDefault();
    if (!newPlatform.trim() || !newUrl.trim()) return;
    await createSocialLink({ platform: newPlatform.trim(), url: newUrl.trim(), sort_order: links.length });
    setLinks(await getSocialLinks());
    setNewPlatform('');
    setNewUrl('');
  }

  async function handleUpdate(id: string, url: string) {
    await updateSocialLink(id, { url });
    setLinks(await getSocialLinks());
  }

  async function handleDelete(id: string) {
    await deleteSocialLink(id);
    setLinks(await getSocialLinks());
  }

  if (loading) return <p className="text-[var(--color-text-muted)]">{t('common.loading')}</p>;

  return (
    <div className="admin-page">
      <h1 className="admin-page__title">{t('admin.socialLinks')}</h1>
      <form onSubmit={handleAdd} className="admin-form-row">
        <div className="admin-form-group" style={{ minWidth: '160px' }}>
          <select
            value={newPlatform}
            onChange={(e) => setNewPlatform(e.target.value)}
          >
            <option value="">{t('admin.selectPlatform')}</option>
            {PLATFORMS.filter((p) => !links.some((l) => l.platform === p)).map((p) => (
              <option key={p} value={p}>{p}</option>
            ))}
          </select>
        </div>
        <div className="admin-form-group" style={{ minWidth: '240px' }}>
          <input
            placeholder="URL"
            value={newUrl}
            onChange={(e) => setNewUrl(e.target.value)}
          />
        </div>
        <button type="submit" className="admin-btn">{t('admin.add')}</button>
      </form>
      <div className="overflow-x-auto">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Platform</th>
              <th>URL</th>
              <th style={{ textAlign: 'right' }}>{t('common.delete')}</th>
            </tr>
          </thead>
          <tbody>
            {links.map((l) => (
              <tr key={l.id}>
                <td>{l.platform}</td>
                <td>
                  <input
                    value={l.url}
                    onChange={(e) => handleUpdate(l.id, e.target.value)}
                    onBlur={(e) => { if (e.target.value !== l.url) handleUpdate(l.id, e.target.value); }}
                    className="admin-table-inline-input"
                  />
                </td>
                <td style={{ textAlign: 'right' }}>
                  <button type="button" onClick={() => handleDelete(l.id)} className="admin-table__danger">{t('common.delete')}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
